import './App.css';
import React,{ Fragment } from 'react';
import { BrowserRouter as Router, Route,Switch  } from "react-router-dom";
import Header from './components/header/Header';
import Home from './components/home/Home';
import Footer from './components/footer/Footer';
import Privacy from './components/privacy/Privacy'
import TermsAndCondition from './components/terms/TermsAndCondition';

function App() {
  return (
    <Fragment>
      <Router>
        <Header/>
        <Switch>
          <Route exact path="/"  component={Home}/>
          <Route path="/privacy-policy" component={Privacy}/>
          <Route path="/terms-and-condition" component={TermsAndCondition}/>

        </Switch>
        <Footer/>
      </Router>
    </Fragment>
  );
}

export default App;
